/**
 * Unique identifiers for tables used in localStorage persistence for column resizing.
 * Each table needs a unique ID to store its column widths separately.
 */
export const TableIds = {
  TEAM_MEMBERS: 'team-members',
  TEAM_MEMBER_CHANGES: 'team-member-changes',
  PROJECTS: 'projects',
  PROJECT_CHANGES: 'project-changes',
  CLIENTS: 'clients',
  BILLS: 'bills',
  INVOICES: 'invoices',
  OVERHEADS: 'overheads',
  GENERATE_INVOICES: 'generate-invoices',
  GENERATE_BILLS: 'generate-bills',
  MEMBER_ACCESS: 'member-access',
  ROLES: 'roles',
  DEPARTMENTS: 'departments',
  SENIORITIES: 'seniorities',
  PERMISSIONS: 'permissions',
  INTEGRATIONS: 'integrations',
  RATE_OVERVIEW: 'rate-overview',
  TIME_TRACKING_APPROVALS: 'time-tracking-approvals',
  TIME_OFF_TYPES: 'time-off-types',
  TIME_OFF_TYPE_CHANGES: 'time-off-type-changes',
  MEMBER_CUSTOM_ATTRIBUTES: 'member-custom-attributes',
  PAYMENT_DETAILS: 'payment-details',
} as const;

export type TableId = (typeof TableIds)[keyof typeof TableIds];
